var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17.222 10H6.778C5 10 4 11 4 13v5c0 2 1 3 2.778 3h10.444C19 21 20 20 20 18v-5c0-2-1-3-2.778-3z","fill":"#3986ED","stroke":"#3986ED","strokeWidth":"1.8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M8 9V6.75c0-.995.421-1.948 1.172-2.652A4.14 4.14 0 0112 3a4.14 4.14 0 012.828 1.098A3.635 3.635 0 0116 6.75V9","stroke":"#3986ED","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Lock.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Lock;

Lock.default = Lock;
